import httpClient from 'utils/httpClient';
import { withPortalScope } from 'utils/portalScope';

export const getList = (params) => {
  return httpClient.get('/product-category', {
    params: withPortalScope(params, { includeBusiness: false, includeStore: false }),
  });
};
export const deleteProductCategory = (params) => {
  const ids = (params || []).map((x) => x.product_category_id);
  return httpClient.post(`/product-category/delete`, { ids });
};
export const getDetail = (id) => {
  return httpClient.get(`/product-category/${id}`);
};
export const create = (params) => {
  return httpClient.post(`/product-category`, params);
};
export const update = (id, params) => {
  return httpClient.put(`/product-category/${id}`, params);
};
export const getNextCode = (params = {}) => {
  return httpClient.get('/product-category/next-code', {
    params: withPortalScope(params, { includeBusiness: false, includeStore: false }),
  });
};
export const getOptionsTreeview = (params = {}) => {
  const scopedParams = withPortalScope(params, { includeBusiness: false, includeStore: false });
  const search = `${scopedParams?.search || ''}`.trim();

  if (search) {
    const { parent_id, ...searchParams } = scopedParams;
    return httpClient.get('/product-category/get-options', {
      params: {
        ...searchParams,
        search,
        limit: searchParams.limit || 50,
      },
    });
  }

  return httpClient.get('/product-category/get-options-treeview', { params: scopedParams });
};
export const getOptions = (params = {}) => {
  return httpClient.get('/product-category/get-options', {
    params: withPortalScope(params, { includeBusiness: false, includeStore: false }),
  });
};
export const exportExcel = (params) => {
  const header = {
    responseType: 'blob',
  };
  return httpClient.get('/product-category/export-excel', { params, ...header });
};

const normalizeProductCategoryAttribute = (item = {}) => ({
  ...item,
  attribute_id: item.attribute_id || item.product_attribute_id,
  product_attribute_id: item.product_attribute_id || item.attribute_id,
  description: item.description || item.attribute_description,
});

export const getListAttributes = async (params = {}) => {
  const attributeType = params?.attribute_type || (String(params?.type || '') !== '0' ? params?.type : null);
  const query = {
    ...params,
    attribute_type: attributeType || undefined,
    is_active: 1,
  };
  delete query.type;

  const data = await httpClient.get('/product-attribute', { params: query });
  return {
    ...data,
    items: (data?.items || []).map(normalizeProductCategoryAttribute),
  };
};
export const createAttribute = (params) => {
  return httpClient.post(`/product-category/attributes`, params);
};
export const getOptionsAttribute = (productCategoryId) => {
  return httpClient.get(`/product-category/${productCategoryId}/attributes/get-options`);
};
const PRODUCT_MODEL_INITIAL_OPTION_LIMIT = 1000;
const PRODUCT_MODEL_SEARCH_OPTION_LIMIT = 100;

export const getOptionsModel = (params = {}) => {
  const { initialLimit, ...requestParams } = params;
  const initialOptionLimit = Math.min(Math.max(Number(initialLimit) || PRODUCT_MODEL_INITIAL_OPTION_LIMIT, 1), PRODUCT_MODEL_INITIAL_OPTION_LIMIT);
  const search = `${params?.search || ''}`.trim();
  const requestedLimit = Math.max(Number(params?.limit) || PRODUCT_MODEL_SEARCH_OPTION_LIMIT, 1);
  const limit = search
    ? Math.min(requestedLimit, PRODUCT_MODEL_SEARCH_OPTION_LIMIT)
    : initialOptionLimit;

  return httpClient.get(`/product-category/${params?.productCategoryId}/product-model/get-options`, {
    params: {
      ...requestParams,
      search: search || undefined,
      limit,
    },
  });
};
export const getMaterialById = (id) => {
  return httpClient.get(`/product-category/material/${id}`);
  //return httpClient.get(`/product-category/${params?.product_category_id}/product-model/get-options`, { params });
};
